import React from 'react';
import AccountsContent from '../function-components/AccountsContent';

function Accounts() {
  return (
    <>
    <AccountsContent />
    </>
  )
}

export default Accounts